import { Typography } from '@mui/material';

export function SelectPlaceholder({ title = 'Select' }: { title?: string }) {
  return (
    <Typography
      variant='body1'
      className='truncate'
      component={'span'}
      sx={{
        color: 'var(--mui-palette-text-disabled)',
        alignContent: 'center',
      }}
    >
      {title}
    </Typography>
  );
}
